export const AUTH_TOKEN = 'auth-token';
export const APP_NAME = <span className="text-branding fw-bold">MeniuM.eu</span>;
